import { Form, FormInstance, Input } from 'antd';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { commonHelpers } from 'utilities/helpers';
import SearchIcon from './../../../../../assets/icons/search-bar-icon.svg';

type props = {
    form: FormInstance<any>;
};

export const SearchBar = ({ form }: props) => {
    return (
        <Form.Item
            required={false}
            className="input-font-style label-form-style "
            name="searchingText"
            label={false}
            rules={[
                () => ({
                    validator(_, value) {
                        if (value && (value.length < 3 || value.length > 100)) {
                            return Promise.reject(
                                new Error(getMessage('In_MinMaxLen', '物件', '3', '100')),
                            );
                        }
                        return Promise.resolve();
                    },
                }),
            ]}
        >
            <Input
                prefix={<img alt="" src={SearchIcon} />}
                style={{ width: 267, height: 40 }}
                placeholder={PLACEHOLDER.PROPERTY_SEARCH_TEXT}
                onBlur={() => {
                    commonHelpers.onBlurTrimFormItem(form, 'searchingText');
                }}
                autoComplete="off"
            />
        </Form.Item>
        
    );
};
